import React from 'react'
import { Timeline } from '@alifd/next'
import { shape } from 'portal/assets/images'
import styles from './index.module.scss'

interface ItemShowProps {
  count: string,
  name: string,
  update: string,
}
interface UsingTrendsProps {
  time: string,
  state: string,
  title: string,
}

export default function ItemShow() {
  const items : ItemShowProps[] = [
    {
      count: '59',
      name: '在研项目',
      update: '',
    },
    {
      count: '25',
      name: '标准表单',
      update: '+2',
    },
    {
      count: '23',
      name: '公开项目',
      update: '',
    },
    {
      count: '14',
      name: '公开数据集',
      update: '',
    },
    {
      count: '2,341',
      name: '科研课程',
      update: '',
    },
    {
      count: '23,341',
      name: '知识图谱',
      update: '',
    },
    {
      count: '23',
      name: '统计方法',
      update: '+2',
    },
    {
      count: '2',
      name: '预测模型',
      update: '',
    },
    {
      count: '200',
      name: '质控参与机构',
      update: '',
    },
    {
      count: '667',
      name: '质控病例累计',
      update: '',
    },
    {
      count: '',
      name: '',
      update: '',
    },
    {
      count: '',
      name: '',
      update: '',
    },
  ]

  const trends : UsingTrendsProps[] = [
    {
      time: '2020-6-2 12:00:00',
      state: '创建了科研项目',
      title: '[宋基会-慢阻肺急性加重患者的注册登记研究]',
    },
    {
      time: '2020-6-1 11:00:00',
      state: '提交了数据使用申请',
      title: '[中国成人肺部健康研究队列]',
    },
    {
      time: '2020-5-18 8:00:01',
      state: '进行了文献检索',
      title: '[COPD]',
    },
    {
      time: '2020-5-12 15:00:11',
      state: '使用了在线统计方法',
      title: '[相关分析]',
    },
    {
      time: '2020-4-2 12:12:00',
      state: '填写了质控表单',
      title: '[呼吸疾病临床诊疗质控和科研转化系统]',
    },
    {
      time: '2020-4-2 12:00:00',
      state: '提交了数据使用申请',
      title: '[中国成人肺部健康研究队列]',
    },
    {
      time: '2020-3-18 8:00:01',
      state: '使用了预测模型系统',
      title: '[慢阻肺死亡风险预测模型]',
    },
    {
      time: '2020-3-12 15:00:11',
      state: '观看了科研课程',
      title: '[单样本分析，统计方法如何选]',
    },
  ]

  function itemShow (props: ItemShowProps) {
    const { count, name, update } = props
    return (
      <ul>
        <span style={{ color: '#FF8300', position: 'absolute', top: 3, left: '45%', fontSize: 16 }}>{ update }</span>
        <li style={{ color: '#202D4C', fontSize: 38, fontWeight: 500, textAlign: 'center' }}>{ count }</li>
        <li style={{ color: '#616A79', fontSize: 16, textAlign: 'center', paddingTop: 6 }}>{ name }</li>
      </ul>
    )

  }

  function usingTrends (props: UsingTrendsProps) {
    const { time, state, title } = props
    return (
      <Timeline.Item title={ state } content={ title } state="process" timeLeft={ time } />
    )
  }
  return(
    <div className={styles.itemShow}>
      <div className={ styles.leftItemShow }>
        { items.map(itemShow) }
        <img src={ shape } alt="" style={{ position: 'absolute', right: 0, bottom: 0 }} />
      </div>
      <div className={ styles.usingTrends }>
        <h2>使用动态</h2>
        <Timeline>
          { trends.map(usingTrends) }
        </Timeline>
        <div style={{ width: 486, height:76, background: 'linear-gradient(180deg,rgba(255,255,255,0.32) 0%,rgba(255,255,255,0.89) 64%,rgba(255,255,255,1) 100%)', position: 'absolute', bottom: 0 }}></div>
      </div>
    </div>
  )
}
